<template>
    <div name="booking" class="booking" v-if="step === 0" >
        <!-- 병원리스트 -->
        <img class="image" src="../../assets/showcase/xi/booking/list/1.png"  @click="goHome"/>
        <img class="image" src="../../assets/showcase/xi/booking/list/2.png" />
        <img class="image" src="../../assets/showcase/xi/booking/list/11.png" @click="selectProfile(0)" />
        <img class="image" src="../../assets/showcase/xi/booking/list/4.png" />
        <img class="image" src="../../assets/showcase/xi/booking/list/11.png" @click="selectProfile(1)"/>
        <img class="image" src="../../assets/showcase/xi/booking/list/5.png" />
        <img class="image" src="../../assets/showcase/xi/booking/list/11.png" @click="selectProfile(2)"/>
        <img class="image" src="../../assets/showcase/xi/booking/list/6.png" />
        <img class="image" src="../../assets/showcase/xi/booking/list/11.png" @click="selectProfile(3)"/>
        <img class="image" src="../../assets/showcase/xi/booking/list/7.png" />
        <img class="image" src="../../assets/showcase/xi/booking/list/11.png" @click="selectProfile(4)"/>
        <img class="image" src="../../assets/showcase/xi/booking/list/8.png" />
        <img class="image" src="../../assets/showcase/xi/booking/list/11.png" @click="selectProfile(5)"/>
        <img class="image" src="../../assets/showcase/xi/booking/list/9.png" />
        <img class="image" src="../../assets/showcase/xi/booking/list/11.png" @click="selectProfile(6)"/>
        <img class="image" src="../../assets/showcase/xi/booking/list/10.png" />
        <!-- <img class="image" src="../../assets/showcase/xi/booking/list/5.png" @click="selectProfile"/>
        <img class="image" src="../../assets/showcase/xi/booking/list/6.png" /> -->
    </div>
    <div class="booking" v-else-if="step === 1" >
        <!-- 프로필 선택 -->
        <img class="image" src="../../assets/showcase/xi/booking/profile/1.png" @click="stepChange(0)" />
        <img class="image" src="../../assets/showcase/xi/booking/profile/2.png" />
        <img class="image" src="../../assets/showcase/xi/booking/profile/3.png" />
        <img class="image" src="../../assets/showcase/xi/booking/profile/4.png" />
        <div class="bottom-button">
            <img class="image" src="../../assets/showcase/xi/booking/profile/5.png" />
            <div class="button1" @click="stepChange(5)"></div>
            <div class="button2" @click="bookingStart"></div>
        </div>
    </div>
    <div class="booking" v-else-if="step === 2">
        <!-- 날짜선택 -->
        <img class="image" src="../../assets/showcase/xi/booking/calendar/1.png" @click="stepChange(1)"/>
        <img class="image" src="../../assets/showcase/xi/booking/calendar/2.png" />
        <calendar 
            @dateSelected="dateSelect"
        />
        <img class="image" src="../../assets/showcase/xi/booking/calendar/3.png" />
    </div>
    <div class="booking" v-else-if="step === 3" >
        <!--  -->
        <img class="image" src="../../assets/showcase/xi/booking/department/1.png" />
        <img class="image" src="../../assets/showcase/xi/booking/department/2.png" />
        <div style="width: 100%;position: relative; aspect-ratio: 8;">
            <img style="position: absolute;left:0; width: 100%;top: 0;" src="../../assets/showcase/xi/booking/department/3.png" @click="stepChange(2)"/>
            <span style="position: absolute;right: 20%;top: 50%; transform: translate(20%, -50%); font-size: 2.5vw;text-align: right; color: #008DEF; font-weight: 600;">{{ bookingDate }} | {{ bookingTime }}</span>
        </div>

        <div class="" v-if="selectedSymptom === 0">
            <img class="image" src="../../assets/showcase/xi/booking/department/4_1_0.png" >
            <img class="image" src="../../assets/showcase/xi/booking/department/4_2_0.png" @click="stepChange(6)"/>
        </div>
        <div class="" v-else-if="selectedSymptom === 1">
            <img class="image" src="../../assets/showcase/xi/booking/department/4_1_1.png" />
            <img class="image" src="../../assets/showcase/xi/booking/department/4_2_1.png" @click="stepChange(6)"/>
        </div>
        <div class="" v-else-if="selectedSymptom === 2">
            <img class="image" src="../../assets/showcase/xi/booking/department/4_1_2.png" />
            <img class="image" src="../../assets/showcase/xi/booking/department/4_2_2.png" @click="stepChange(6)"/>
        </div>
        <div class="" v-else-if="selectedSymptom === 3">
            <img class="image" src="../../assets/showcase/xi/booking/department/4_1_3.png" />
            <img class="image" src="../../assets/showcase/xi/booking/department/4_2_3.png" @click="stepChange(6)"/>
        </div>
        <div class="" v-else-if="selectedSymptom === 4">
            <img class="image" src="../../assets/showcase/xi/booking/department/4_1_4.png" />
            <img class="image" src="../../assets/showcase/xi/booking/department/4_2_4.png" @click="stepChange(6)"/>
        </div>
        <div class="" v-else-if="selectedSymptom === 5">
            <img class="image" src="../../assets/showcase/xi/booking/department/4_1_5.png" />
            <img class="image" src="../../assets/showcase/xi/booking/department/4_2_5.png" @click="stepChange(6)"/>
        </div>
        <div class="" v-else-if="selectedSymptom === 6">
            <img class="image" src="../../assets/showcase/xi/booking/department/4_1_6.png" />
            <img class="image" src="../../assets/showcase/xi/booking/department/4_2_6.png" @click="stepChange(6)"/>
        </div>
        <div class="" v-else-if="selectedSymptom === 7">
            <img class="image" src="../../assets/showcase/xi/booking/department/4_1_7.png" />
            <img class="image" src="../../assets/showcase/xi/booking/department/4_2_7.png" @click="stepChange(6)"/>
        </div>
        <div class="" v-else-if="selectedSymptom === 8">
            <img class="image" src="../../assets/showcase/xi/booking/department/4_1_8.png" />
            <img class="image" src="../../assets/showcase/xi/booking/department/4_2_8.png" @click="stepChange(6)"/>
        </div>
        <div class="" v-else-if="selectedSymptom === 9">
            <img class="image" src="../../assets/showcase/xi/booking/department/4_1_9.png" />
            <img class="image" src="../../assets/showcase/xi/booking/department/4_2_9.png" @click="stepChange(6)"/>
        </div>

        <img class="image" src="../../assets/showcase/xi/booking/department/6.png" />
        <img class="image" src="../../assets/showcase/xi/booking/department/7.png" @click="completeCheck" />
        <img class="image" src="../../assets/showcase/xi/booking/department/8.png" />
    </div>
    <div class="modal-overlay" v-else-if="step === 6" @click.self="stepChange(3)">
        <div class="modal-sheet">
            <div class="modal-title">증상을 선택해주세요</div>
            <div class="symptom-list">
                <div class="symptom-item" v-for="(symptom, index) in symptoms" :key="index" @click="selectSymptom(index)">
                    <span>{{ symptom }}</span>
                    <svg v-if="selectedSymptom === index" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M5 13L9 17L19 7" stroke="#4CAF50" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>
    <!-- 여기에 선택된 병원이름 넣기 -->
    <div class="modal-overlay" v-else-if="step === 4" @click.self="stepChange(3)">
        <!-- <img class="image" src="../../assets/showcase/xi/booking/complete/1.png" @click="stepChange(3)"/>
        <div style="position: fixed; bottom: calc(100vw * 120 / 375); width: calc(100% - 12.4px - 7.1vw);  display: flex;flex-direction: column;">
            <img class="image" src="../../assets/showcase/xi/booking/complete/2.png" />
            <img class="image" src="../../assets/showcase/xi/booking/complete/3.png" @click="goHistory"/>
        </div> -->

        <div class="confirm-sheet">
            <div class="confirm-title">마지막으로 예약 확인할게요!</div>
            <div class="confirm-card">
                <div class="confirm-card-header">
                    <span class="confirm-icon">&#x1F4CB;</span>
                    <span class="confirm-card-title">예약 정보</span>
                </div>
                <div class="confirm-info">
                    <div class="info-row">
                        <span class="info-label">진료병원</span>
                        <span class="info-value">{{ hospitals[selectedHospital] }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">날짜/시간</span>
                        <div class="info-value">
                            <div><b>{{ bookingDate }}</b></div>
                            <div><b>{{ bookingTime }}</b></div>
                        </div>
                    </div>
                    <div class="info-row">
                        <span class="info-label">진료 증상</span>
                        <span class="info-value">{{ symptoms[selectedSymptom] }}</span>
                    </div>
                    <div class="info-row"><span class="info-label">이름</span><span class="info-value">김솔닥</span></div>
                    <div class="info-row"><span class="info-label">휴대폰번호</span><span class="info-value">010-1234-1234</span></div>
                    <div class="info-row"><span class="info-label">생년월일</span><span class="info-value">1987.11.12</span></div>
                </div>
            </div>
            <button class="confirm-btn" @click="goHistory">진료 예약하기</button>
        </div>
    </div> 
    <div class="booking" v-else-if="step === 5" >
        <img class="image" src="../../assets/showcase/xi/my/1/1.png" @click="stepChange(1)"/>
        <img class="image" src="../../assets/showcase/xi/my/1/2.png" />
        <img class="image" src="../../assets/showcase/xi/my/1/3.png" @click="stepChange(1)"/>
        <img class="image" src="../../assets/showcase/xi/my/1/4.png" />
    </div>   
</template>

<script>
import Calendar from '@/components/showcase/Calendar';
export default {
  components: { Calendar },
    name: 'booking',
    props: ['outStep'],
    data: function()
    {
        return {
            step: 0,
            preStep: 0,
            selectedSymptom: 2,
            selectedHospital: 0,
            symptoms: [
                '일반진료', '다이어트', '감기', '여드름', '탈모',
                '보습제', '안구건조증', '그 외 진료', '지난 진료와 같음', '코로나'
            ],
            hospitals: [
                '하나내과의원', '늘푸른의원', '센텀하나의원', '아이사랑의원',
                '뷰티크의원', '성모산부인과의원', '안과의원'
            ],
            calendarDate: null,
            calendarSlot: ''
        }
    },
    computed: {
        bookingDate: function() {
            var d = this.calendarDate || new Date();
            return d.getFullYear() + '년 ' + (d.getMonth() + 1) + '월 ' + d.getDate() + '일';
        },
        bookingTime: function() {
            if (this.calendarSlot) return this.calendarSlot;
            var now = new Date();
            var h = now.getHours();
            var m = now.getMinutes();
            var start = Math.floor(m / 10) * 10;
            var end = start + 30;
            var endH = h;
            if (end >= 60) { end -= 60; endH += 1; }
            var pad = function(n) { return n < 10 ? '0' + n : '' + n; };
            return pad(h) + ':' + pad(start) + '~' + pad(endH) + ':' + pad(end);
        }
    },
    mounted: function()
    {
        this.scrollToTop();
        if(this.outStep !== null)
        {
            this.step = this.outStep
        }
    },
    methods: {
        scrollToTop() {
            const el = document.getElementById('app')
            if (el) {
                el.scrollTo({
                    top: 0               
                })
            }
        },
        selectProfile: function(hospital)
        {
            this.selectedHospital = hospital;
            this.preStep = this.step
            this.step = 1;
            this.reset();
        },
        bookingStart: function()
        {
            this.scrollToTop();
            this.preStep = this.step
            this.step = 2;
            this.reset();
        },
        profileUpdate: function()
        {
            this.preStep = this.step
            this.step = 5;
            this.reset();
        },
        dateSelect: function(payload)
        {
            if (payload) {
                this.calendarDate = payload.date;
                this.calendarSlot = payload.slot;
            }
            this.scrollToTop();
            this.preStep = this.step
            this.step = 3;
            this.reset();
        },
        completeCheck: function()
        {
            this.preStep = this.step
            this.step = 4;
            this.reset();
        },
        stepChange: function(step)
        {
            this.step = step;
            this.reset();
        },
        goHistory: function()
        {
            this.$emit('goHistory')
        },
        selectSymptom: function(index)
        {
            this.selectedSymptom = index;
            this.stepChange(3);
        },
        goHome: function()
        {
            this.$emit('goHome')
        },
        reset: function()
        {
            this.$emit('resetCount')
        }
    }
}
</script>

<style scoped>
    .image {
        width: 100%;
    }
    
    .booking {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        background: #FFF;
    }
    .bottom-button {
        bottom: calc(100vw * 120 / 375);
        position: fixed; 
        width: calc(100% - 12.4px - 8vw);
    }
    .button1 {
        position: absolute;
        width: 50%;
        height: 100%;
        top: 0;
        left: 0;
    }   
    .button2 {
        position: absolute;
        width: 50%;
        height: 100%;
        top: 0;
        right: 0;
    }
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: calc(100vw * 120 / 375);      
        background: rgba(0, 0, 0, 0.6);
        z-index: 999;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        box-sizing: border-box;
    }
    .modal-sheet {
        width: calc(100% - 12.4px - 8vw);
        background: #FFF;
        border-radius: 20px 20px 0 0;
        padding: 5vw 2vw calc(100vw * 60 / 375 + 20px);
    }
    @keyframes slideUp {
        from { transform: translateY(100%); }
        to { transform: translateY(0); }
    }
    .modal-title {
        font-family: Pretendard, sans-serif;
        font-size: 3vw;
        font-weight: 700;
        color: #1A1A1A;
        padding: 0 4px 16px;
    }
    .symptom-list {
        display: flex;
        flex-direction: column;
    }
    .symptom-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.7vw 1.2vw;
        font-family: Pretendard, sans-serif;
        font-size: 2.5vw;
        color: #333;
        cursor: pointer;
    }
    .symptom-item:active {
        background: #F8F8F8;
    }

    /* step 4 - confirm modal */
    .confirm-sheet {
        width: calc(100% - 12.4px - 8vw);
        background: #FFF;
        border-radius: 20px 20px 0 0;
        padding: 5.5vw 4vw calc(100vw * 60 / 375 + 10px);     

    }
    .confirm-title {
        font-family: Pretendard, sans-serif;
        font-size: 3.8vw;
        font-weight: 700;
        color: #1A1A1A;
        margin-bottom: 2.5vw;
    }
    .confirm-card {
        background: #F7F8FA;
        border-radius: 12px;
        padding: 3vw;
        margin-bottom: 3vw;
    }
    .confirm-card-header {
        display: flex;
        align-items: center;
        gap: 6px;
        padding-bottom: 2vw;
        border-bottom: 1px solid #E8E8E8;
        margin-bottom: 2vw;
    }
    .confirm-icon {
        font-size: 3.5vw;
    }
    .confirm-card-title {
        font-family: Pretendard, sans-serif;
        font-size: 3vw;
        font-weight: 700;
        color: #1A1A1A;
    }
    .confirm-info {
        display: flex;
        flex-direction: column;
        gap: 2.2vw;
        padding: 2vw 0;
        box-sizing: border-box;
    }
    .info-row {
        display: flex;
        align-items: flex-start;
        gap: 4vw;
    }
    .info-label {
        font-family: Pretendard, sans-serif;
        font-size: 2.8vw;
        color: #999;
        min-width: 16vw;
        flex-shrink: 0;
    }
    .info-value {
        font-family: Pretendard, sans-serif;
        font-size: 2.8vw;
        color: #1A1A1A;
    }
    .info-value b {
        font-weight: 400;
    }
    .confirm-btn {
        width: 100%;
        padding: 3.5vw;
        background: #008DEF;
        color: #FFF;
        border: none;
        border-radius: 8px;
        font-family: Pretendard, sans-serif;
        font-size: 3.5vw;
        font-weight: 600;
        cursor: pointer;
    }
    .confirm-btn:active {
        background: #008DEF;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Booking.vue